import { render, staticRenderFns } from "./turnover-group-info-app.vue?vue&type=template&id=7fa9fcd1"
import script from "./turnover-group-info-app.vue?vue&type=script&lang=js"
export * from "./turnover-group-info-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports